import PropTypes from 'prop-types'
import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const ExpandMore = ({ className }) => <ExpandMoreIcon className={className} />

export default ExpandMore

ExpandMore.propTypes = {
  className: PropTypes.string
}
